








































































import Vue from 'vue'

import {
  IChecklist,
  IChecklistTemplate,
  IItemReference,
} from '@/api/types/response.types'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default Vue.extend({
  name: 'ChecklistsDrawer',

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    originatingConversation: {
      type: Object as () => IItemReference,
      default: null,
    },
    originatingTask: {
      type: Object as () => IItemReference,
      default: null,
    },
    originatingChecklist: {
      type: Object as () => IChecklist,
      default: null,
    },
    existingChecklists: {
      type: Array as () => IChecklist[],
      default: (): IChecklist[] => [],
    },
  },

  data() {
    return {
      isLoading: false,
      closeDrawerOnOutsideClick: true,
      drawerOpened: false,
      addUpdateChecklistFormSelected: true,
      checklistTemplates: [] as IChecklistTemplate[],
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '100%'
      }
      return '680px'
    },
    projectID(): number {
      return Number(this.$route.params.id)
    },
    editingChecklist(): boolean {
      return this.originatingChecklist != null
    },
  },

  async created() {
    if (this.originatingChecklist == null) {
      const checklistTemplatesReponse = await InternalProjectsAPI.get_ChecklistTemplates(
        this.projectID,
      )

      this.checklistTemplates = checklistTemplatesReponse.filter(
        (template: IChecklistTemplate) => template.statusID === null,
      )
      if (this.checklistTemplates.length !== 0) {
        this.addUpdateChecklistFormSelected = false
      }
    }
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
      if (this.checklistTemplates.length !== 0) {
        this.addUpdateChecklistFormSelected = false
      }
    },

    handleCreated(checklist: IChecklist) {
      this.$emit('checklist-created', checklist)
      this.handleCancel()
    },

    handleDeleted(checklist: IChecklist) {
      this.$emit('checklist-deleted', checklist)
      this.handleCancel()
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },
  },
})
